import { baseUrlXmailing } from "@/shared/http/api";

export default {
    appDownload: () => ({
        method: 'POST',
        url: 'api/event/create',
        baseURL: baseUrlXmailing
    })
}
